import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { capitaliseText, isNotEmpty } from "../../../helpers/StringHelpers"
import { UnitNumberValidator } from "../../../services/validation/address-employment-form/UnitNumberValdation"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const FloorNumberField = (props: FormFieldProps<string>) => {
    const { t } = useTranslation(`signup`)
    const [errorMessage, setErrorMessage] = useState(``)
    const {
        defaultValue,
        handleChange,
        errorText,
        isDisabled,
    } = props
    const [value, setValue] = useState(defaultValue || ``)

    useEffect(() => {
        setErrorMessage(errorText ?? ``)
    }, [defaultValue, errorText])

    const validateField = (value: string) => {
        const validator = new UnitNumberValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const text = capitaliseText(event.target.value)
        const REGEX = /^[a-zA-Z0-9-]+$/g
        if (text === `` || REGEX.test(text)) {
            setValue(text)
            handleChange(text)
        }
    }

    const handleOnBlur = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        validateField(event.target.value)
    }

    return (
        <TextField
            fullWidth
            defaultValue={defaultValue}
            error={isNotEmpty(errorMessage)}
            helperText={t(errorMessage)}
            id="floor-number"
            label={t(`floor_number`)}
            value={value}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            inputProps={{ maxLength: 2 }}
            disabled={isDisabled}
        />
    )
}

export { FloorNumberField }